import KanbanPipelinesAPI from 'dashboard/api/kanbanPipelines';
import { createStore } from 'dashboard/store/storeFactory';

export const useKanbanPipelinesStore = createStore({
  name: 'kanbanPipelines',
  type: 'pinia',
  API: KanbanPipelinesAPI,

  getters: {
    getPipelines: state =>
      state.records
        .slice()
        .sort(
          (a, b) => a.position - b.position || a.name.localeCompare(b.name)
        ),
  },
});
